import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="auto__container">
        <div className="footer__inner">
          <Link to="" className="footer__inner-logo">
            <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="" />
          </Link>
        </div>
      </div>
    </footer>
  );
}
